import React from 'react';

const Privacy = () => {
  return (
    <section id="privacy" className="legal-section">
      <div className="container">
        <h2 className="section-title">Política de Privacidad</h2>
        <div className="legal-content">
          <p>
            En Cita Facil, respetamos tu privacidad y nos comprometemos a proteger tus datos personales.
          </p>
          <h3>Uso de Datos</h3>
          <p>
            Los datos que proporcionas se utilizan únicamente para la gestión de citas de extranjería.
            No vendemos ni compartimos tus datos personales con terceros.
          </p>
          <h3>Seguridad</h3>
          <p>
            Implementamos medidas de seguridad adecuadas para proteger tu información personal.
          </p>
          <p>
            Si tienes preguntas sobre nuestra política de privacidad, contáctanos vía WhatsApp.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
